import { Capacitor } from "@capacitor/core";

/**
 * Reemplaza localhost por 10.0.2.2 cuando se ejecuta en Android
 * 10.0.2.2 es la IP especial del emulador Android para acceder al localhost de la máquina host
 * @param {string} url - URL original
 * @returns {string} URL con localhost reemplazado si está en Android
 */
export function getApiUrl(url) {
  if (!url) return url;
  
  // Solo reemplazar si estamos en una plataforma nativa (Android/iOS)
  if (Capacitor.isNativePlatform()) {
    // Reemplazar localhost por 10.0.2.2 (IP del emulador para acceder al host)
    return url
      .replace(/http:\/\/localhost:(\d+)/g, 'http://10.0.2.2:$1')
      .replace(/https:\/\/localhost:(\d+)/g, 'https://10.0.2.2:$1');
  }
  
  // En web, devolver la URL sin cambios
  return url;
}

/**
 * Obtiene la URL base de la API, reemplazando localhost si es necesario
 * @param {string} baseUrl - URL base de la variable de entorno
 * @returns {string} URL base ajustada para la plataforma
 */
export function getApiBaseUrl(baseUrl) {
  return getApiUrl(baseUrl || import.meta.env.VITE_API_BASE_URL);
}
